import { FunctionalComponent, h } from 'preact';

import { PreactPortalComponent } from 'common/module/preact/portal/component';
import { SnackbarComponent } from 'library/snackbar/component';

import { MessagePropsInterface } from './props.interface';

export const MessageTemplate: FunctionalComponent<MessagePropsInterface> = (props) => (
  <PreactPortalComponent into='body'>
    <SnackbarComponent {...props} />
  </PreactPortalComponent>
);
